module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Tiny House")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("By Charley Descoteaux")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("A Buchanan House Love Story")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Pride weekend is over, but for Nathan Lucas, the summer is just heating up. He appears to have it all. He’s tall and blond, ripped and handsome, and half owner of Buchanan House, a successful gay retreat on Oregon’s beautiful central coast. But his "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("joie de vivre")]), _vm._v(" hides a fear of abandonment. When he was twelve, his mother had triplets, and instead of the cherished only child, Nathan became a scapegoat for his exhausted parents, and he has never truly dealt with that pain.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Portland chef Paulie Nesbitt is head over heels in love with Nathan. They’ve been drinking buddies with benefits for years, while Paulie has not-so-secretly yearned for more. Paulie’s extra pounds and self-doubt have kept him from acting on his feelings. Their friends know they would make the perfect couple, but Nathan and Paulie will have to let go of past insecurities if they want a future together.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0